import * as React from "react";
import { userManager } from "../services/sso";
import { useHistory } from "react-router-dom";
import { ROUTE_PATH_HOME } from "../routes";

const OidcLogoutPage: React.FC = () => {
    const history = useHistory();

    React.useEffect(() => {
        userManager.signoutRedirectCallback().then(() => {
            //// this will take the user to the projects home page after login.
            //// We are replacing the history so that the user cannot go back to this page and get stuck.
            history.replace(ROUTE_PATH_HOME);
        });
    });

    return <></>;
};

export default OidcLogoutPage;
